import React, { useState, useEffect, useCallback } from 'react';
import './BottomMenu.css';
import MenuButton from './MenuButton';
import Store from '../../../core/Store';
import {ILaunchedScenario} from '../../../misc/helpers';

const BottomMenu = (props : any) => {
	const menuStore = 'menu-BC';
	const launchedScenarioStore = 'launchedScenario-BC';
	const [menu, setMenu] = useState<IMenu>(null);
	
	let activeTabMenues = menu == null ? [] : menu.practice.active ? menu.practice.scenarios : menu.test.scenarios;

	let disabledtest = menu ? menu.practice.scenarios.some((scenario : IScenario) => !scenario.completed) : true;

	let store = new Store;

	const saveMenuCallback = useCallback((newMenu) => {
		store.set(menuStore, JSON.stringify(newMenu));
		setMenu(newMenu);
	}, []);

	const listItems = activeTabMenues.map((btn, index) =>
		<MenuButton
			key={btn.id}
			text={btn.title}
			disabled={btn.disabled}
			completed={btn.completed}
			color={btn.color}
			index={index}
			onClick={() => {
				if (!btn.disabled){
					let nextElemIndex = activeTabMenues.length > index + 1 ? index + 1 : activeTabMenues.length -1;
					props.scenarioLaunch(btn);

					let activeScenario : ILaunchedScenario = {
						active: btn.id,
						next: activeTabMenues[nextElemIndex].id,
						isCompleted: false,
						isPractive: menu.practice.active
					};
					store.set(launchedScenarioStore, JSON.stringify(activeScenario));
				}
			}}
		/>
	);

	function copyArray(array: Array<any>) {
		return JSON.parse(JSON.stringify(array));
	}

	function mapScenarioClick(menu : IMenu, menuScenarios : any){
		console.log(menu);
		menu.practice.scenarios.map((item : any) => item.onClick = menuScenarios.find((s : any) => s.id == item.id).onClick);
		menu.test.scenarios.map((item : any) => item.onClick = menuScenarios.find((s : any) => s.id == item.id).onClick);
		return menu;
	}

	useEffect(() => {
		let scenarios : Array<IScenario> = [];
		let savedMenu = JSON.parse(store.get(menuStore));
		let menuScenarios = props?.menuScenarios;
		if (!savedMenu) {
			menuScenarios.forEach((value : IScenario) => {
				scenarios.push({			
					id: value.id,
					text: value.text,
					title: value.title,
					description: value.description,
					link: value.link,
					background: value.background,
					backgrounds: value.backgrounds,
					audio: value.audio,
					disabled: true,
					completed: false,
					color: '',
					onClick: null
		
				}
			)});

			let defaultMenu = {
				practice: {
					active: true,
					scenarios: copyArray(scenarios.slice(0, 4))
				},
				test: {
					active: false,
					scenarios: copyArray(scenarios.slice(4, 9))
				},
			};

			defaultMenu.practice.scenarios[0].disabled = false;
			defaultMenu.test.scenarios.sort( () => .5 - Math.random());

			defaultMenu.test.scenarios[0].disabled = false;

			defaultMenu = mapScenarioClick(defaultMenu, menuScenarios);

			store.set(menuStore, JSON.stringify(defaultMenu));

			setMenu(defaultMenu);
		}
		else {
			savedMenu = mapScenarioClick(savedMenu, menuScenarios);
			setMenu(savedMenu);
		}

		// let laucnhedMenu = JSON.parse(store.get(launchedScenarioStore)) as ILaunchedScenario;
		// if(laucnhedMenu && laucnhedMenu.isCompleted){
		// 	completeScenario(laucnhedMenu.isPractive, laucnhedMenu.active, laucnhedMenu.next); //use this code to complete the scenario
		// }
	}, []);
		
	
	useEffect(() => {
		let laucnhedMenu = JSON.parse(store.get(launchedScenarioStore)) as ILaunchedScenario;
		if(menu && laucnhedMenu && laucnhedMenu.isCompleted){
			completeScenario(laucnhedMenu.isPractive, laucnhedMenu.active, laucnhedMenu.next); //use this code to complete the scenario
		}
	}, [menu]);

	function selectpractice(e : any){
		saveMenuCallback({ 
			...menu, 
			practice: {
				...menu.practice,
				active : true
			},
			test: {
				...menu.test,
				active : false
			}
		});
	}	

	function selecttest(e: any){
		if(!disabledtest)
			saveMenuCallback({ 
				...menu, 
				practice: {
					...menu.practice,
					active : false
				},
				test: {
					...menu.test,
					active : true
				}
			});
	}		

	function completeScenario(isPractive : boolean, currentScenarioId : number, nextScenarioId : number){
		let scenarios = isPractive ? menu.practice.scenarios : menu.test.scenarios;
		scenarios.forEach((el :IScenario) => {
			if (el.id == currentScenarioId) el.completed = true;
			if (el.id == nextScenarioId) el.disabled = false;
		});

		let practiceCompleted = menu.practice.scenarios.every((el :IScenario) => el.completed);

		if(isPractive){
			saveMenuCallback({ 
				...menu, 
				practice: {
					...menu.practice,
					scenarios: scenarios
				},
				test: {
					...menu.test,
					active: practiceCompleted
				}
			});
		}
		else{
			saveMenuCallback({ 
				...menu, 
				practice: {
					...menu.practice,
				},
				test: {
					scenarios: scenarios,
					active: practiceCompleted
				}
			});
		}

		store.set(launchedScenarioStore, null);//in case no launched scenario active
	}

	const onSelectPracticeKeyboard = (e:any)=> {
		if(e.keyCode == 32 || e.keyCode == 13 && props.onClick){ //32 - spacebar, 36 - enter
			selectpractice(e);
		}
	};
	const onSelectTestKeyboard = (e:any)=> {
		if(e.keyCode == 32 || e.keyCode == 13 && props.onClick){ //32 - spacebar, 36 - enter
			selecttest(e);
		}
	};
	return (
		<div className="ui-inner-container bottom-panel modal-disable-select">
			<div className="bottom-panel-background">
				<div className={`bottom-panel-front ${menu?.practice?.active ? 'practice' : menu?.test?.active ? 'test' : ''}`} >
					<div
						tabIndex={0}
						aria-label={"practice scenarios, unlocked"}
						className={`tab-button tab-button-practice ${menu?.practice?.active ? 'active' : 'inactive'}`}
						onClick={selectpractice}
						onKeyDown={onSelectPracticeKeyboard}
					>
						practice scenarios
					</div>
					<div
						tabIndex={0}
						aria-label={"test scenarios" + (disabledtest ? " locked" : "unlocked")}
						role={disabledtest ? "" : "button"}
						className={`tab-button tab-button-test ${disabledtest ? 'disabled-tab' : ''} ${menu?.test?.active ? 'active' : ''}`}
						onClick={selecttest}
						onKeyDown={onSelectTestKeyboard}
					>
						TEST SCENARIOS
						{disabledtest ? <span className="lock-img"></span> : ''}
					</div>
					{listItems}
				</div>
			</div>
		</div>
	);
};

export default BottomMenu;

export interface IMenu {
	practice: {
		active: boolean,
		scenarios: Array<IScenario>
	},
	test: {
		active: boolean,
		scenarios: Array<IScenario>
	},
  }
export interface IScenario {
	id: number,
	text: string,
	title: string,
	description: string,
	audio: string,
	link: string,
	background: string,
	backgrounds: string[],
	disabled: boolean,
	completed: boolean,
	color: string,
	onClick: any
}